import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./metaPixel";

function ScrollToTop() {
  const location = useLocation();
  const firstRender = useRef(true);

  // Meta Pixel: index.html fires the first PageView; fire one per route change after that.
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname, location.search]);

  useEffect(() => {
    const { hash, pathname, search } = location;

    if (hash) {
      const id = hash.replace('#', '');
      const scrollToAnchor = () => {
        const el = document.getElementById(id) || document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      // Try immediately, then again on next tick in case content hasn't mounted
      scrollToAnchor();
      setTimeout(scrollToAnchor, 50);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    // Depend on discrete parts to avoid unnecessary triggers
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default ScrollToTop;
